<div
  id="overlay-parent-container"
  class="parent-container top-controls-v2"
  #videoTowerParentContainer
  [hidden]="(numberOfActualPresentParticipants$ | async) === 0"
  [class.full-screen]="(currentSessionView$ | async) === sessionView.FULLSCREEN"
  [class.wb]="
    (currentSessionView$ | async) === SessionView.WHITEBOARD ||
    (currentSessionView$ | async) === SessionView.FULLSCREEN_APP
  "
  [class.new-vct-right-controls]="videoCallControlsService.showNewVctRightControls$ | async"
  [class.edge-aligned-arrows]="edgeAlignedArrows$ | async"
  [class.layout-top]="(sessionSharedDataService.controlsLayout | async) === VideoLayout.TOP"
  [class.layout-right-new]="(sessionSharedDataService.controlsLayout | async) === VideoLayout.RIGHT"
  [class.layout-minimized-new]="
    (sessionSharedDataService.controlsLayout | async) === VideoLayout.MINIMIZED
  "
  [class.layout-floating]="
    (sessionSharedDataService.controlsLayout | async) === VideoLayout.FLOATING
  "
  [class.new-gallery-bar-ui]="this.galleryBottomBarStateService.galleryBarShown$ | async"
  [ngStyle]="
    (currentSessionView$ | async) === SessionView.GALLERY_VIEW ||
    (currentSessionView$ | async) === SessionView.EXPANDED
      ? { width: '100%' }
      : (sessionSharedDataService.controlsLayout | async) === VideoLayout.RIGHT &&
        ((currentSessionView$ | async) === SessionView.WHITEBOARD ||
          (currentSessionView$ | async) === SessionView.FULLSCREEN_APP)
      ? {
          minWidth: (resizedRightViewMinWidth$ | async) + 'px',
          minHeight: (rightViewHeight$ | async) + 'px',
          maxHeight: (rightViewHeight$ | async) + 'px',
          width: (rightViewWidth$ | async) + 'px',
          height: (rightViewHeight$ | async) + 'px',
          resize: flagsService.featureFlagsVariables.dynamic_right_view?.resizable_tower
            ? 'horizontal'
            : 'none',
          direction:
            flagsService.featureFlagsVariables.dynamic_right_view?.resizable_tower &&
            (directionForLocale$ | async) === LocalDirection.LTR
              ? LocalDirection.RTL
              : LocalDirection.LTR
        }
      : {}
  "
  [@openClose]="{
    value:
      (sessionSharedDataService.controlsLayout | async) === VideoLayout.FLOATING ||
      (startAnimation$ | async)
        ? 'closed'
        : 'open'
  }"
  [style.right]="
    (currentSessionView$ | async) === SessionView.FULLSCREEN_APP &&
    (isMobileView$ | async) === false
      ? 0
      : ''
  "
  [style.marginTop]="
    (currentSessionView$ | async) === SessionView.FULLSCREEN_APP &&
    (isMobileView$ | async) === false
      ? '-22px'
      : 0
  "
>
  <div
    id="parent-container"
    [style.width]="'100%'"
    [style.height]="'100%'"
    [style.direction]="
      (directionForLocale$ | async) === LocalDirection.LTR ? LocalDirection.LTR : LocalDirection.RTL
    "
    appTilesContainerObserver
    [numberOfTiles]="numberOfTilesForLayout$ | async"
    [currentSessionView]="currentSessionView$ | async"
    [isMobileView]="isMobileView$ | async"
    [rightViewVideoCallControlshidden]="observerModeActive$ | async"
    [clearLatestEmittedChange]="rtcServiceController.service.isConnected()"
    (changeTilesContainerParameters)="updateTilesContainerParameters($event)"
  >
    <ng-container *ngIf="fullScreenAppTileState$ | async as fullScreenAppState">
      <div
        class="video-tile full-screen-app-tile"
        [class.is-mobile]="isMobileDevice || (isMobileView$ | async)"
        [ngStyle]="{
          position: 'absolute',
          display:
            ((currentSessionView$ | async) === SessionView.WHITEBOARD ||
              (currentSessionView$ | async) === SessionView.FULLSCREEN_APP) &&
            (sessionSharedDataService.controlsLayout | async) === VideoLayout.MINIMIZED
              ? 'none'
              : 'unset'
        }"
        [style.width.px]="fullScreenAppState.width"
        [style.height.px]="fullScreenAppState.height"
        [style.top.px]="fullScreenAppState.top"
        [style.left.px]="fullScreenAppState.left"
        [hidden]="
          (pictureInPictureService.isPIPActive$ | async) || fullScreenAppState.visible === false
        "
      >
        <div #appGalleryElementHost [style.width]="'100%'" [style.height]="'100%'">
          <app-screen-share-annotations-overlay
            *ngIf="
              isScreenShareAnnotationsEnabled &&
              (currentSessionView$ | async) === SessionView.EXPANDED &&
              (shouldDisableAnnotations$ | async) === false
            "
            [trackSid]="fullScreenAppState.config.uid"
            [isMobileView]="isMobileDevice || (isMobileView$ | async)"
            [isCurrentFullscreenTile]="true"
            [currentUser]="false"
            [fullScreenAppHTMLElement]="fullScreenAppState.appElement"
          >
          </app-screen-share-annotations-overlay>
        </div>
      </div>
    </ng-container>

    <ng-container>
      <div
        *ngFor="let tile of visibleTilesForLayout$ | async; trackBy: trackById; let i = index"
        class="video-tile"
        [class.is-mobile]="isMobileDevice || (isMobileView$ | async)"
        [ngStyle]="{
          position: 'absolute',
          display:
            ((currentSessionView$ | async) === SessionView.WHITEBOARD ||
              (currentSessionView$ | async) === SessionView.FULLSCREEN_APP) &&
            (sessionSharedDataService.controlsLayout | async) === VideoLayout.MINIMIZED
              ? 'none'
              : 'unset'
        }"
        [style.width.px]="tile.width$ | async"
        [style.height.px]="tile.height$ | async"
        [style.top.px]="tile.top$ | async"
        [style.left.px]="tile.left$ | async"
        [hidden]="(tile.visible$ | async) === false"
      >
        <ng-container
          *ngTemplateOutlet="
            sessionCallUserTemplate;
            context: { tile: tile, oneOnOneUiVm: null, isOverlaySelfTile: false }
          "
        ></ng-container>
      </div>
    </ng-container>

    <ng-container
      *ngIf="{
        isOneOnOne: (isOneOnOneModeActive$ | async),
        uiVm: (oneOnOneUiVm$ | async),
        largeTile: (largeTile$ | async),
        selfTile: (overlaidSelfTile$ | async)
      } as oneOnOneVm"
    >
      <app-one-on-one-self-overlay
        *ngIf="
          oneOnOneVm.isOneOnOne && oneOnOneVm.uiVm && oneOnOneVm.largeTile && oneOnOneVm.selfTile
        "
        [hidden]="
          (oneOnOneVm.selfTile.visible$ | async) === false ||
          (((currentSessionView$ | async) === SessionView.WHITEBOARD ||
            (currentSessionView$ | async) === SessionView.FULLSCREEN_APP) &&
            (sessionSharedDataService.controlsLayout | async) === VideoLayout.MINIMIZED)
        "
        [largeTile]="oneOnOneVm.largeTile"
        [selfTile]="oneOnOneVm.selfTile"
        [overlaySizePercent]="oneOnOneVm.uiVm.overlaySizePercent"
        [overlayAspectRatio]="oneOnOneVm.uiVm.overlayAspectRatio"
        [selfTileResizeEnabled]="oneOnOneVm.uiVm.selfTileResizeEnabled"
      >
        <ng-container
          *ngTemplateOutlet="
            sessionCallUserTemplate;
            context: {
              tile: oneOnOneVm.selfTile,
              oneOnOneUiVm: oneOnOneVm.uiVm,
              isOverlaySelfTile: true
            }
          "
        ></ng-container>
      </app-one-on-one-self-overlay>
    </ng-container>

    <ng-container
      *ngIf="
        ((currentSessionView$ | async) === sessionView.GALLERY_VIEW ||
          (currentSessionView$ | async) === sessionView.EXPANDED) &&
        $any(numberOfUserTilesPages$ | async) > 1 &&
        (navigationLeftButtonPosition$ | async)
      "
    >
      <div
        class="nav-btn-container"
        [ngStyle]="{ position: 'absolute' }"
        [style.top.px]="(navigationLeftButtonPosition$ | async)?.top"
        [style.left.px]="(navigationLeftButtonPosition$ | async)?.left"
      >
        <app-pencil-button
          class="gv-nav-button"
          [disabled]="(currentUserTilesPageIndex$ | async) === 0"
          [iconConfig]="{
            type: 'material-icon'
          }"
          [icon]="
            (navigationLeftButtonPosition$ | async)?.width
              ? 'keyboard_arrow_up'
              : 'keyboard_arrow_left'
          "
          [style.--pencil-button-width]="
            (navigationLeftButtonPosition$ | async)?.width
              ? (navigationLeftButtonPosition$ | async)?.width + 'px'
              : null
          "
          (clickEvent)="navigateTiles(currentUserTilesPageIndex$.getValue() - 1)"
        >
        </app-pencil-button>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        ((currentSessionView$ | async) === SessionView.WHITEBOARD ||
          (currentSessionView$ | async) === SessionView.FULLSCREEN_APP) &&
        (sessionSharedDataService.controlsLayout | async) !== VideoLayout.MINIMIZED &&
        (sessionSharedDataService.isControlsCollapsed | async) === false &&
        $any(numberOfUserTilesPages$ | async) > 1 &&
        (navigationLeftButtonPosition$ | async)
      "
    >
      <div
        class="nav-btn-container"
        [ngStyle]="{ position: 'absolute' }"
        [style.top.px]="(navigationLeftButtonPosition$ | async)?.top"
        [style.left.px]="(navigationLeftButtonPosition$ | async)?.left"
      >
        <ng-container
          *ngIf="videoCallControlsService.showNewVctRightControls$ | async; else mobileLeftButton"
        >
          <app-pencil-button
            class="vct-nav-button"
            theme="icon"
            [disabled]="(currentUserTilesPageIndex$ | async) === 0"
            [iconConfig]="{
              type: 'material-icon'
            }"
            icon="expand_less"
            (clickEvent)="navigateTiles(currentUserTilesPageIndex$.getValue() - 1)"
          >
          </app-pencil-button>
        </ng-container>

        <ng-template #mobileLeftButton>
          <button
            id="left-button"
            class="left-button"
            (click)="navigateTiles(currentUserTilesPageIndex$.getValue() - 1)"
            [disabled]="(currentUserTilesPageIndex$ | async) === 0"
          >
            <span class="material-icons">chevron_left</span>
          </button>
        </ng-template>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        ((currentSessionView$ | async) === sessionView.GALLERY_VIEW ||
          (currentSessionView$ | async) === sessionView.EXPANDED) &&
        $any(numberOfUserTilesPages$ | async) > 1 &&
        (navigationRightButtonPosition$ | async)
      "
    >
      <div
        class="nav-btn-container"
        [ngStyle]="{ position: 'absolute' }"
        [style.--pencil-button-width]="(navigationRightButtonPosition$ | async)?.width"
        [style.top.px]="(navigationRightButtonPosition$ | async)?.top"
        [style.left.px]="(navigationRightButtonPosition$ | async)?.left"
      >
        <app-pencil-button
          class="gv-nav-button"
          [disabled]="
            (currentUserTilesPageIndex$ | async) === $any(numberOfUserTilesPages$ | async) - 1
          "
          [iconConfig]="{
            outlined: true,
            type: 'material-icon'
          }"
          [icon]="
            (navigationRightButtonPosition$ | async)?.width
              ? 'keyboard_arrow_down'
              : 'keyboard_arrow_right'
          "
          [style.--pencil-button-width]="
            (navigationRightButtonPosition$ | async)?.width
              ? (navigationRightButtonPosition$ | async)?.width + 'px'
              : null
          "
          (clickEvent)="navigateTiles(currentUserTilesPageIndex$.getValue() + 1)"
        >
        </app-pencil-button>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        ((currentSessionView$ | async) === SessionView.WHITEBOARD ||
          (currentSessionView$ | async) === SessionView.FULLSCREEN_APP) &&
        (sessionSharedDataService.controlsLayout | async) !== VideoLayout.MINIMIZED &&
        (sessionSharedDataService.isControlsCollapsed | async) === false &&
        $any(numberOfUserTilesPages$ | async) > 1 &&
        (navigationRightButtonPosition$ | async)
      "
    >
      <div
        class="nav-btn-container"
        [ngStyle]="{ position: 'absolute' }"
        [style.top.px]="(navigationRightButtonPosition$ | async)?.top"
        [style.left.px]="(navigationRightButtonPosition$ | async)?.left"
      >
        <ng-container
          *ngIf="videoCallControlsService.showNewVctRightControls$ | async; else mobileRightButton"
        >
          <app-pencil-button
            class="vct-nav-button"
            theme="icon"
            buttonType="button"
            [disabled]="
              (currentUserTilesPageIndex$ | async) === $any(numberOfUserTilesPages$ | async) - 1
            "
            [iconConfig]="{
              outlined: true,
              type: 'material-icon'
            }"
            icon="expand_more"
            (clickEvent)="navigateTiles(currentUserTilesPageIndex$.getValue() + 1)"
          >
          </app-pencil-button>
        </ng-container>

        <ng-template #mobileRightButton>
          <button
            id="right-button"
            class="right-button"
            (click)="navigateTiles(currentUserTilesPageIndex$.getValue() + 1)"
            [disabled]="
              (currentUserTilesPageIndex$ | async) === $any(numberOfUserTilesPages$ | async) - 1
            "
          >
            <span class="material-icons">chevron_right</span>
          </button>
        </ng-template>
      </div>
    </ng-container>
    <div
      id="video-controls"
      class="video-controls"
      [class.wb-view]="
        (currentSessionView$ | async) === SessionView.WHITEBOARD ||
        (currentSessionView$ | async) === SessionView.FULLSCREEN_APP
      "
      [class.gallery-view]="(currentSessionView$ | async) === SessionView.GALLERY_VIEW"
      [class.expand-view]="(currentSessionView$ | async) === SessionView.EXPANDED"
      [class.full-screen]="(currentSessionView$ | async) === SessionView.FULLSCREEN"
      [class.is-mobile]="isMobileDevice || (isMobileView$ | async)"
      [class.new-gallery-bar-ui]="this.galleryBottomBarStateService.galleryBarShown$ | async"
      [class.new-vct-right-controls]="videoCallControlsService.showNewVctRightControls$ | async"
    >
      <div
        *ngIf="
          (sessionSharedDataService.controlsLayout | async) === VideoLayout.MINIMIZED &&
          ((currentSessionView$ | async) === SessionView.WHITEBOARD ||
            (currentSessionView$ | async) === SessionView.FULLSCREEN_APP)
        "
        class="d-flex minimized-speaker-bar align-items-center justify-content-between"
        (click)="expandVideoTower()"
      >
        <div class="d-flex align-items-center flex-1 overflow-hidden cmr-8">
          <!-- Left icon: Speaking icon for all cases -->
          <div *ngIf="participantsSpeaking.size !== 0" class="speaking-indicator">
            <app-pencil-icon
              height="13px"
              width="17px"
              *ngIf="uiService.isMobile | async; else desktopIcon"
              [type]="'svg-icon'"
              [name]="'incoming_audio'"
            ></app-pencil-icon>
            <ng-template #desktopIcon>
              <app-pencil-icon
                width="18px"
                height="18px"
                name="graphic_eq"
                [type]="'mat-icon'"
              ></app-pencil-icon>
            </ng-template>
          </div>

          <span class="cml-8 font-16 flex-1 overflow-hidden white-space-nowrap speaking-text">
            {{
              participantsSpeaking.size === 0
                ? ('No one is speaking' | translate)
                : participantsSpeaking.size > 1
                ? ('Multiple people' | translate)
                : (speakingUser$ | async)?.user?.name +
                  ((speakingUser$ | async)?.isLocal ? ' ' + ('(You)' | translate) : '')
            }}
          </span>
        </div>
        <app-pencil-icon
          class="unfold-icon"
          name="unfold_more"
          [type]="'material-icon'"
          [outlined]="true"
        ></app-pencil-icon>
      </div>
      <app-wb-video-controls
        [localParticipantId]="localParticipantId$ | async"
        [isFloatingVideo]="
          (sessionSharedDataService.controlsLayout | async) === VideoLayout.FLOATING
        "
        (returnToWhiteboard)="returnToWhiteboard()"
        (exitCurrentScreen)="!isLeaderModeActive$.getValue() && handleExitCurrentScreen($event)"
      >
      </app-wb-video-controls>
    </div>
  </div>

  <div class="resizer-icon" *ngIf="(isMobileView$ | async) === false && !isFirefox">
    <app-pencil-icon name="resizer" [type]="'svg-icon'"></app-pencil-icon>
  </div>
  <div
    id="overlay-parent-container-resizer"
    [hidden]="
      (currentSessionView$ | async) !== SessionView.WHITEBOARD &&
      (currentSessionView$ | async) !== SessionView.FULLSCREEN_APP
    "
    *ngIf="!!flagsService.featureFlagsVariables.dynamic_right_view?.resizable_tower"
    [ngClass]="{
      'resizer-l': (directionForLocale$ | async) !== LocalDirection.LTR,
      'resizer-r': (directionForLocale$ | async) === LocalDirection.LTR
    }"
    class="resizer"
    (mousedown)="activateVideoTowerResizer(videoTowerParentContainer)"
  ></div>
</div>

<ng-template
  #sessionCallUserTemplate
  let-tile="tile"
  let-oneOnOneUiVm="oneOnOneUiVm"
  let-isOverlaySelfTile="isOverlaySelfTile"
>
  <app-session-call-user
    class="d-flex w-100 h-100"
    *ngIf="tile.user$ | async as tileUser"
    [id]="
      ((tile.track$ | async) == TrackType.SCREEN ? 'screen-tile-' : 'video-tile-') +
      ((tile.participant$ | async)
        ? (tile.participant$ | async)?.participantId
        : (tile.user$ | async)?._id)
    "
    [sessionView]="currentSessionView$ | async"
    [isCurrentExpandedTile]="
      ((expandedScreenUser$ | async)?.participant$ | async) &&
      ((expandedScreenUser$ | async)?.participant$ | async)?.participantId ===
        (tile.participant$ | async)?.participantId &&
      ((expandedScreenUser$ | async)?.track$ | async) === (tile.track$ | async) &&
      (currentSessionView$ | async) === SessionView.EXPANDED
    "
    [isCurrentFullscreenTile]="
      ((expandedScreenUser$ | async)?.participant$ | async)?.participantId ===
        (tile.participant$ | async)?.participantId &&
      (currentSessionView$ | async) === SessionView.FULLSCREEN &&
      ((expandedScreenUser$ | async)?.track$ | async) === (tile.track$ | async)
    "
    [renderHoverControls]="
      ((numberOfActualPresentParticipants$ | async) !== 1 || (observerModeActive$ | async)) &&
      (isOverlayDragging$ | async) === false &&
      !(isChildModeActive$ | async)
    "
    [videoTrackType]="tile.track$ | async"
    [scaleSize]="
      (tile.width$ | async) ? $any(tile.width$ | async) / rightViewMinTileNeededWidth : 1
    "
    [user]="tile.user$ | async"
    [currentUser]="(tile.user$ | async) && (tile.user$ | async)?._id === user?._id"
    [rtcConnecting]="rtcServiceController.service.isConnecting()"
    [participant]="tile.participant$ | async"
    [raiseHand]="
      (tile.track$ | async) === TrackType.VIDEO &&
      (raiseHandRepositoryService.getUserRaiseHand$(tileUser._id) | async)
    "
    [emojiId]="(tile.track$ | async) === TrackType.VIDEO ? (tile.emojiId$ | async) : -1"
    [isActiveLeaderMode]="isLeaderModeActive$ | async"
    [userIsSpeaking]="
      (this.participantsSpeaking.has((tile.participant$ | async)?.participantId) &&
        (tile.track$ | async) !== TrackType.SCREEN) ||
      (this.screenSharingHasAudio.has((tile.participant$ | async)?.participantId) &&
        (tile.track$ | async) !== TrackType.VIDEO)
        ? true
        : false
    "
    [hideSelfViewActive]="
      (tile.participant$ | async)?.local &&
      (hideSelfVideoButtonStateService.active$ | async) &&
      (tile.track$ | async) === TrackType.VIDEO
    "
    [visibilityIndex]="tile.visibilityIndex$ | async"
    [isMobileView]="uiService.isMobile.value"
    [VCTCurrentColsNum]="rightViewCurrentColsNum$ | async"
    [pipVideoActive]="tile.pipVideo$ | async"
    [isOneOnOneModeActive]="isOneOnOneModeActive$ | async"
    [isOneOnOneOverlaySelfTile]="isOverlaySelfTile"
    [isRightView]="
      ((currentSessionView$ | async) === SessionView.WHITEBOARD ||
        (currentSessionView$ | async) === SessionView.FULLSCREEN_APP) &&
      (sessionSharedDataService.controlsLayout | async) === VideoLayout.RIGHT
    "
    [hideNameTag]="oneOnOneUiVm?.hideNameTag ?? false"
    [hideInstitutionLogo]="oneOnOneUiVm?.hideInstitutionLogo ?? false"
    [hideInactiveIndicator]="oneOnOneUiVm?.hideInactiveIndicator ?? false"
    [hideReactions]="oneOnOneUiVm?.hideReactions ?? false"
    [hideRaiseHandIcon]="oneOnOneUiVm?.hideRaiseHandIcon ?? false"
    [hideSpeakingIcon]="oneOnOneUiVm?.hideSpeakingIcon ?? false"
    [hideErrorIndicator]="oneOnOneUiVm?.hideErrorIndicator ?? false"
    [profileImageSize]="oneOnOneUiVm?.profileImageSize ?? null"
    [showSpeakingBorder]="isOverlaySelfTile || (isOneOnOneModeActive$ | async) === false"
    (fullscreen)="!isLeaderModeActive$.getValue() && handleFullscreen(tile, $event)"
    (expand)="!isLeaderModeActive$.getValue() && handleExpand(tile, $event)"
    (currentlySpeaking)="
      handleSpeakingParticipant(tile.participant$.getValue()?.participantId, $event)
    "
    (insertRemoteVideo)="
      addRemoteVideo(tile.participant$.getValue()?.participantId, tile.track$.getValue())
    "
    (screenshot)="handleScreenshot(tile)"
    (pipVideo)="openPiPVideo(tile, $event)"
  >
  </app-session-call-user>
</ng-template>
